// extracted by mini-css-extract-plugin
export default {"section":"MoviesList_section__EXPbH","movies-list":"MoviesList_movies-list__WNOg-"};